export default __webpack_public_path__ + "images/graphics/leasing-partner-wave-back.svg";